export { default } from './GoToTopButton';
